/** 预览模式下,如果没有保存过canvas数据, 则根据会议信息计算一次默认封面\嘉宾\日程等 */

import type { ActivitiesPublicRegistrationPageRes } from '@quickService/ActivitiesPublicRegistrationPage';
import type { SchedulerDataList } from '@quickService/PublicRegistrationQueryEventSchedulers';
import type {
  IComponentMeta,
  NodeSchema,
  PageSchema,
  IPackageDesc,
} from '@tencent/ep-canvas-sdk/src/designer/types';
import axios from 'axios';

export const getIdGen = (prefix = 'node_') => {
  let cur = Date.now();
  return () => `${prefix}${(cur += 1).toString(12)}`;
};

const getNodeId = getIdGen();
const ROOT_ID = '__root__';

export const compMeta2Schema = (meta: IComponentMeta): (NodeSchema & { title: string }) | null =>
  !meta
    ? null
    : {
        title: meta.componentDisplayName,
        componentName: meta.componentName,
        id: getNodeId(),
        // 从卡片标题或者组件名生成卡片别名
        nodeAlias: `${
          meta.props.find((p) => p.name === 'title')?.defaultValue.text ||
          meta.componentDisplayName.split('-').shift()
        }#01`,
        props: meta.props.reduce(
          (prev, cur) => ({ ...prev, [cur.name]: cur.defaultValue }),
          {},
        ) as Record<string, any>,
      };

export const transform = ({
  meta,
  eventDetail,
  schedules,
}: {
  meta: IComponentMeta[];
  eventDetail: ActivitiesPublicRegistrationPageRes['data'];
  schedules: SchedulerDataList;
}) => {
  const nav = compMeta2Schema(meta.find((meta) => meta.cardTag === 'nav')!);
  const page: PageSchema = {
    componentName: 'Page',
    id: ROOT_ID,
    children: nav ? [nav] : [],
    nodeAlias: 'Page#01',
    props: { color: 'white' },
  };
  const addChild = (node: NodeSchema | null) => {
    if (!node) return;
    page.children.push(node);
    // @ts-ignore
    nav?.props.navItems.push({
      id: node.id,
      link: node.id,
      name: node.nodeAlias?.split('#').shift(),
    });
  };
  const cover = compMeta2Schema(meta.find((meta) => meta.cardTag === 'cover')!);
  addChild(cover);

  const guestCard = compMeta2Schema(meta.find((meta) => meta.cardTag === 'info_guest')!);
  if (eventDetail?.guest?.length && guestCard) {
    guestCard.props!.guests = [];
    eventDetail.guest.forEach((guest) => {
      // @ts-ignore
      guestCard.props.guests.push({
        id: guest.id,
        name: guest.name,
        title: guest.company,
        title2: guest.position,
        desc: guest.introduction,
        avatar: { cosId: guest.photo_cosId, src: guest.photo_url },
      });
    });
    addChild(guestCard);
  }
  if (schedules?.length) {
    // 日程卡片直接从context拿,不需要根据数据生成卡片内容
    const scheduleCard = compMeta2Schema(meta.find((meta) => meta.cardTag === 'schedule')!);
    addChild(scheduleCard);
  }

  return page;
};

/** 根据主题名称获取对应的 package 地址 */
export const getPackageByTheme = (theme = 'theme-concise'): IPackageDesc[] => [
  {
    package: theme,
    type: 'cdn',
    // 'https://test-102.cicd.tencentmeeting.com/canvas/events-place/js/theme-concise.json'
    assets: `/canvas/events-place/js/${theme}.json`,
    urls: [`/canvas/events-place/js/${theme}.js`, `/canvas/events-place/css/${theme}.css`],
  },
];

export const createSimpleFromEvent = (
  eventDetail: ActivitiesPublicRegistrationPageRes['data'],
  schedules: SchedulerDataList,
) => {
  const defaultTheme = getPackageByTheme();
  return axios.get(defaultTheme[0].assets).then((data) => ({
    packages: defaultTheme,
    schema: transform({
      meta: data.data,
      eventDetail,
      schedules,
    }),
  }));
};

export default transform;
